<template>
	<div class="frame-cls">
		<el-tabs v-if="list.length > 0" v-model="StoreSessionCurrentNode.uuid" class="title-tabs">
			<template>
				<el-tab-pane :label="item.q" :name="item.uuid" v-for="item in list" :key="item.uuid">
					<Info @emitUnfoldAside="$emit('emitUnfoldAside')" :currentNode="currentNode" @drawerKnowInfoClose="handleClose" :row="item" />
				</el-tab-pane>
			</template>
		</el-tabs>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import Info from './Info';
export default {
	name: 'KnowledgeInfoPage',
	props: ['cell', 'currentNode'],
	components: {Info},
	computed: {
		...mapGetters([
			'StoreSessionCurrentNode',
		])
	},
	data() {
		return {
			list: []
		}
	},
	watch: {
		cell: {
			handler: function(val) {
				if(val) {
					const result = this.list.some(item => item.uuid === val.uuid);
					if(result) return;
					this.list.push(val);
				}
			},
			immediate: true,
			deep: true
		},
	},
	methods: {
		handleClose(type, uuid, update) {
			if(type === 'end') {
				for(let i = 0; i < this.list.length; i++) {
					if(uuid === this.list[i]['uuid']) {
						this.list.splice(i, 1);
					}
				}
			}
			this.$emit('drawerKnowInfoClose', update);
		}
	}
}
</script>

<style lang="scss" scoped>
.frame-cls {
	width: 100%;
	height: 100%;

	& > .title-tabs {
		height: calc(100% + 55px);
		position: relative;
		top: -55px;
	}
}
</style>